export const ALG_GAME_TYPE_STORAGE = 1;
export const ALG_GAME_TYPE_MIN = 1;
export const ALG_GAME_TYPE_MAX = 99;
export const ALG_ALL_GAMES_NAME = 'All ALG Games';

export function isAlgGameTypeRange(gameTypeId) {
  const id = Number(gameTypeId);
  return id >= ALG_GAME_TYPE_MIN && id <= ALG_GAME_TYPE_MAX;
}

export function isAlgStoredGameType(item) {
  const gameType = Number(item.gameType);
  if (isAlgGameTypeRange(gameType)) {
    return true;
  }
  return gameType === ALG_GAME_TYPE_STORAGE;
}

export function buildGameTypeOptionsForSelect(rawList) {
  const nonAlg = (rawList || [])
    .map(({ id, name }) => ({ id: Number(id), name }))
    .filter(({ id }) => !isAlgGameTypeRange(id))
    .filter(({ id }) => id !== ALG_GAME_TYPE_STORAGE);

  return [
    { id: ALG_GAME_TYPE_STORAGE, name: ALG_ALL_GAMES_NAME },
    ...nonAlg,
  ].sort((a, b) => a.id - b.id);
}

export function toStorageGameType(selectedGameTypeId) {
  const selectedId = Number(selectedGameTypeId);
  if (selectedId === ALG_GAME_TYPE_STORAGE) {
    return {
      gameType: ALG_GAME_TYPE_STORAGE,
      algGameType: null,
    };
  }
  return {
    gameType: selectedId,
    algGameType: null,
  };
}

export function getDisplayGameTypeId(item) {
  if (isAlgStoredGameType(item)) {
    return ALG_GAME_TYPE_STORAGE;
  }
  return Number(item.gameType);
}

export function getGameTypeName(gameTypeOptions, item) {
  if (isAlgStoredGameType(item)) {
    return ALG_ALL_GAMES_NAME;
  }
  const displayId = Number(item.gameType);
  const option = gameTypeOptions.find(g => Number(g.id) === displayId);
  return option ? option.name : String(displayId);
}

export function formatGameTypeDisplay(gameTypeOptions, item) {
  const displayId = getDisplayGameTypeId(item);
  return `${getGameTypeName(gameTypeOptions, item)} (${displayId})`;
}

export function gameTypeOptionLabel(option) {
  if (!option) return '';
  return `${option.id} - ${option.name}`;
}
